import { ColumnDefinition } from '@approvalmax/ui/src/components';
import { UserAvatar } from 'shared/components';

import { ColumnId, UserRow } from './UserList.types';

export const textFieldWidth = 253;

export const checkboxCoverColumn: ColumnDefinition<UserRow> = {
    id: ColumnId.Checkbox,
    width: 48,
    textAlign: 'center',
    headerTextAlign: 'center',
    value: (item) => <UserAvatar size={40} user={item} />,
};
